/**
 * @generated SignedSource<<ecdf2719376f1eed9330fe1c441f1df5>>
 * @relayHash b3232d7b92ac553b47d3583f5d7896c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 657198e5f5de7fb58234d83366348f1e6bc455797a0a585d72acdc8bd0087e33

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type utils_triggerRovoAgentInBulkMutation$variables = {
  agentId: string;
  issueAris: ReadonlyArray<string>;
};
export type utils_triggerRovoAgentInBulkMutation$data = {
  readonly devai_invokeAutodevRovoAgentInBulk: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly failedIssues: ReadonlyArray<{
      readonly conversationId: string | null | undefined;
      readonly issue: {
        readonly key: string;
        readonly webUrl: AGG$URL | null | undefined;
      } | null | undefined;
      readonly issueId: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly succeededIssues: ReadonlyArray<{
      readonly conversationId: string | null | undefined;
      readonly issueId: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type utils_triggerRovoAgentInBulkMutation = {
  response: utils_triggerRovoAgentInBulkMutation$data;
  variables: utils_triggerRovoAgentInBulkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueAris"
},
v2 = [
  {
    "kind": "Variable",
    "name": "agentId",
    "variableName": "agentId"
  },
  {
    "kind": "Variable",
    "name": "issueIds",
    "variableName": "issueAris"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "conversationId"
},
v4 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v5 = {
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v7 = {
  "concreteType": "DevAiInvokeAutodevRovoAgentInBulkIssueResult",
  "kind": "LinkedField",
  "name": "succeededIssues",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/)
  ]
},
v8 = {
  "kind": "ScalarField",
  "name": "success"
},
v9 = {
  "kind": "ScalarField",
  "name": "message"
},
v10 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v11 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v12 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "utils_triggerRovoAgentInBulkMutation",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "DevAiInvokeAutodevRovoAgentInBulkPayload",
        "kind": "LinkedField",
        "name": "devai_invokeAutodevRovoAgentInBulk",
        "plural": false,
        "selections": [
          {
            "concreteType": "DevAiInvokeAutodevRovoAgentInBulkIssueResult",
            "kind": "LinkedField",
            "name": "failedIssues",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ]
              }
            ]
          },
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "utils_triggerRovoAgentInBulkMutation",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "DevAiInvokeAutodevRovoAgentInBulkPayload",
        "kind": "LinkedField",
        "name": "devai_invokeAutodevRovoAgentInBulk",
        "plural": false,
        "selections": [
          {
            "concreteType": "DevAiInvokeAutodevRovoAgentInBulkIssueResult",
            "kind": "LinkedField",
            "name": "failedIssues",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v12/*: any*/)
                ]
              }
            ]
          },
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/)
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "657198e5f5de7fb58234d83366348f1e6bc455797a0a585d72acdc8bd0087e33",
    "metadata": {},
    "name": "utils_triggerRovoAgentInBulkMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "56fe382d6a3a0be60c2eeb8706e10093";

export default node;
